import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import AvailableFeature from '@app/store/transport-layer/subscription/AvailableFeatureItem';
import FeatureUsage from '@app/store/transport-layer/subscription/FeatureUsageItem';
import PlanItem from '@app/store/transport-layer/subscription/PlanItem';

export interface CreateNextPaymentEstimationResponse {
  amount: number;
  deductionAmount: number;
  deductionItems: Array<AvailableFeature | FeatureUsage | PlanItem>;
  finalAmount: number;
  prorationMonth: number | null;
  purchaseItems: Array<AvailableFeature | FeatureUsage | PlanItem>;
}

export function createNextPaymentEstimation(
  workspaceId: string
): Promise<CreateNextPaymentEstimationResponse> {
  return requestApi<CreateNextPaymentEstimationResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/next-payment/estimation`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
